module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00004-fs8.b940852.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00004-fs8.png
// module id = 158
// module chunks = 0